module.exports = __webpack_public_path__ + "img/seowork-screen.5276d820.svg";